
const checkAuth = () => {
  var token=localStorage.getItem('token')
  if(!token){
    localStorage.clear()
    return false
  }
  return true
}

const getAuthHeader = () =>{
  if(localStorage.getItem('token')){

    const expiresDate = new Date(parseInt(localStorage.getItem('expires')));
    const now = new Date();
    if (expiresDate > now) {
      return {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    } else {
      localStorage.clear();
      window.location.href = '';
    }
  }
  else return {}

}

const getAuthHeaderJson = () =>{
  if(localStorage.getItem('token')){
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('token'),
      'Content-Type': '*/*'
    }
  }
  else return {}

}

const getToken = () => {
  return localStorage.getItem('token')
}

const getTokenIfExist = () => {
 if (localStorage.getItem('token')) {
   return localStorage.getItem('token')
 } else {
   localStorage.clear()
   window.location.href = "/#/login"
 }

}

const getUser= () =>{
  if(checkAuth()){
    var user=localStorage.getItem('user')
    return JSON.parse(user);
  }
 else return null
}
const getCompany= () =>{
  if(checkAuth()){
    var company=localStorage.getItem('company')
    return JSON.parse(company);
  }
 else return null
}
const showNotification = (context, message, type) => {

  if(type=='success')
  {
    context.$buefy.toast.open({
      duration: 3000,
      message,
      type: 'is-success'
    })
  }

  if(type=='info')
  {
    context.$buefy.toast.open({
      duration: 3000,
      message,
      type: 'is-info'
    })
  }


  if(type=='error')
  {
    context.$buefy.toast.open({
      duration: 3000,
      message,
      type: 'is-danger'
    })
  }


  if(type=='warning')
  {
    context.$buefy.toast.open({
      duration: 3000,
      message,
      type: 'is-warning'
    })
  }

}

const getUnidades = ()=>{
  return JSON.parse(localStorage.getItem('misunidades'))
}
const getUnidadesDam = ()=>{
  return JSON.parse(localStorage.getItem('misunidadesDam'))
}
const getNombreDocumentoByTipo=(tipo)=>{
  if (tipo=='01') return 'Factura'
  if (tipo=='03') return 'Boleta'
  if (tipo=='07') return 'Nota de crédito'
  if (tipo=='08') return 'Nota de débito'
  if (tipo=='20') return 'Retención'
  if (tipo=='40') return 'Percepción'
  if (tipo=='09') return 'Guía de Remisión'
  if (tipo=='31') return 'Guía Transporte'
  return 'Desconocido'
}

const getCatalogoArancel = () => {
  return [
    { id: 1, partida: "1701130000", description: "Azúcar de caña", sunatCode: "50161509" },
    { id: 2, partida: "1701140000", description: "Los demás azúcares de caña", sunatCode: "50161509" },
    { id: 3, partida: "1701910000", description: "Con adición de aromatizante o colorante", sunatCode: "50161509" },
    { id: 4, partida: "1701999000", description: "Los demás", sunatCode: "50161509" },
    { id: 5, partida: "1703900000", description: "Melaza de caña", sunatCode: "50161509" },
    { id: 6, partida: "2207100000", description: "Alcohol etílico sin desnaturalizar con grado alcohólico volumétrico superior o igual al 80 % vol", sunatCode: "12352104" },
    { id: 7, partida: "2207200010", description: "Alcohol carburante", sunatCode: "12352104" },
    { id: 8, partida: "2207200090", description: "Los demás", sunatCode: "12352104" },
    { id: 9, partida: "2208901100", description: "Alcohol etílico sin desnaturalizar con grado alcohólico volumétrico inferior al 80% vol", sunatCode: "12352104" },
    { id: 10, partida: "1006200000", description: "Arroz descascarillado (arroz cargo o arroz pardo)", sunatCode: "50221101" },
    { id: 11, partida: "1006300000", description: "Arroz semiblanqueado o blanqueado, incluso pulido o glaseado", sunatCode: "50221101" },
    { id: 12, partida: "1006400000", description: "Arroz partido", sunatCode: "50221101" },
    { id: 13, partida: "2302200000", description: "No vigente", sunatCode: "50221101" }
  ];
};

export default {
  checkAuth,
  getAuthHeader,
  getAuthHeaderJson,
  getToken,
  getTokenIfExist,
  getUser,
  getCompany,
  showNotification,
  getUnidades,
  getUnidadesDam,
  getNombreDocumentoByTipo,
  getCatalogoArancel
}




// WEBPACK FOOTER //
// ./src/util/index.js